import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { Store, useAppDispatch } from 'src/redux/Store';
import { useSelector } from 'react-redux';
import { ENTITIES } from 'src/models/QuerybuilderModel';
import { PAYMENT_STATUS, PAYMENT_TYPE, PaymentsModel } from 'src/models/PaymentModel';
import { DIALOGS } from 'src/models/DialogModel';
import { openDialog } from 'src/redux/actions/dialogActions';
import { t } from 'src/lib/language';

const CancelPaymentButton = (props: ButtonProps) => {
  const dispatch = useAppDispatch();

  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.payments] || [],
  );
  const lang = useSelector((state: Store) => state.language.language);

  const payments = useSelector(
    (state: Store) => selections.map(
      (id: number) => state.payments[id],
    ) ?? [] as PaymentsModel,
  );

  const { disabled } = props;

  const containUncancellablePayment = () => {
    const uncancellableStatuses = new Set([
      PAYMENT_STATUS.pending,
      PAYMENT_STATUS.refunded,
      PAYMENT_STATUS.refunding,
      PAYMENT_STATUS.cancelled,
      PAYMENT_STATUS.cancellation,
    ]);

    return payments.some((payment: any) => {
      if (!payment) return false;
      if (uncancellableStatuses.has(payment.payment_status)) return true;
      const isOnline = [PAYMENT_TYPE.cc, PAYMENT_TYPE.eft].includes(payment.payment_type);
      return isOnline && payment.payment_status === PAYMENT_STATUS.paid;
    });
  };

  const handleOpen = () => {
    dispatch(openDialog({ dialog: DIALOGS.cancelPayments }));
  };

  return (
    <>
      <Tooltip
        title={t(lang, 'menus.cancel_payment')}
        placement="top-start">
        <span>
          <ActionButton
            variant="outlined"
            category={MENU_BUTTON_CATEGORY.action}
            onClick={handleOpen}
            disabled={disabled || containUncancellablePayment()}>
            <CancelPresentationIcon />
          </ActionButton>
        </span>
      </Tooltip>
    </>
  );
};

export default CancelPaymentButton;
